<app-dashboard-option [categories]="['CELLS']" [label]="'GAP'" [information]="'PIXEL'">
  <div app-dashboard-option-content>
    <app-number [value]="dashboardLayout.gap" (sendValue)="receiveValue($event)" [color]="color" [min]="0" [max]="20" [step]="5"></app-number>
  </div>
</app-dashboard-option>